export const CALCULATE = "CALCULATE"; // calculate current operation
export const ADD = "ADD"; // entering keys into the pad
export const RECALL = "RECALL"; // recall past calculations
export const CLEAR = "CLEAR"; // Clear what is on the screen
export const BACKSPACE = "BACKSPACE";
